/* Gosu interaction FX: glow + tilt + animated border + click-spark.
 * Auto-tags existing cards/buttons via a selector map (no markup edits).
 * Loaded on index + page templates only. Pairs with gosu-fx.css.
 * Style matches homepage-polish.js (IIFE, ES5, NodeList.forEach). */
(function (window, document) {
  'use strict';

  var SELECTOR_MAP = [
    /* tilt — a few marquee cards per page */
    { sel: '.section-dreamrank .services-block .boxinner', fx: 'tilt' },
    { sel: '.cu-card', fx: 'tilt' },
    { sel: '.section-meet-coaches .boxinner', fx: 'tilt' },
    { sel: '.learn_block', fx: 'tilt' },
    /* tilt on B2B/shared sections (cards with overhanging icon/number decor —
       glow's overflow:hidden would clip them) */
    { sel: '.section-gose-method .boxinner', fx: 'tilt' },
    { sel: '.section-work-gosu-academy .infobox .boxinner', fx: 'tilt' },
    { sel: '.sction-future-education .boxinner', fx: 'tilt' },
    /* glow — dense grids/tiles */
    { sel: '.sction-partners .boxinner', fx: 'glow' },
    { sel: '.sction-blog .boxinner', fx: 'glow' },
    { sel: '.sction-education-classrooms .boxinner', fx: 'glow' },
    /* glow on B2B/shared sections (flat cards, no overhanging decor) */
    { sel: '.sction-services-blocks .boxinner', fx: 'glow' },
    { sel: '.section-testimonials1 .testimonial-item', fx: 'glow' },
    { sel: '.plan_block:not(.pro_gold_plan)', fx: 'glow' },
    /* tilt (not glow): these cards have an .iconbox at top:-80px that glow's
       overflow:hidden would clip. Tilt adds no overflow:hidden. */
    { sel: '.section-flexible-partnership-models .col:not(.plan-featured) .boxinner', fx: 'tilt' },
    /* border — key CTAs + featured cards (present on nearly every page) */
    { sel: '.pro_gold_plan', fx: 'border' },
    { sel: '.section-flexible-partnership-models .plan-featured .boxinner', fx: 'border' },
    { sel: '.main-banner .caption-box .btnarea .btn', fx: 'border' },
    { sel: '.sction-right-content .btnarea .btn', fx: 'border' },
    { sel: '.sction-left-content .btnarea .btn', fx: 'border' }
  ];

  function env(overrides) {
    overrides = overrides || {};
    var mm = window.matchMedia;
    return {
      fine: 'fine' in overrides ? overrides.fine
        : !!(mm && mm('(hover: hover) and (pointer: fine)').matches),
      reduce: 'reduce' in overrides ? overrides.reduce
        : !!(mm && mm('(prefers-reduced-motion: reduce)').matches)
    };
  }

  /* Add effect class + inject any layer the effect needs.
   * Idempotent: an element already carrying data-gosu-fx is skipped.
   * Returns the number of elements newly tagged. */
  function tagTargets(root, map) {
    var count = 0;
    map.forEach(function (entry) {
      root.querySelectorAll(entry.sel).forEach(function (el) {
        if (el.hasAttribute('data-gosu-fx')) return;
        el.setAttribute('data-gosu-fx', entry.fx);
        el.classList.add('gosu-fx--' + entry.fx, 'gosu-fx-host');
        if (entry.fx === 'glow') {
          var glow = document.createElement('span');
          glow.className = 'gosu-fx__glow';
          glow.setAttribute('aria-hidden', 'true');
          el.insertBefore(glow, el.firstChild);
        } else if (entry.fx === 'tilt') {
          var glare = document.createElement('span');
          glare.className = 'gosu-fx__glare';
          glare.setAttribute('aria-hidden', 'true');
          el.appendChild(glare);
        }
        count++;
      });
    });
    return count;
  }

  function bindGlow(card) {
    var glow = card.querySelector('.gosu-fx__glow');
    if (!glow) return;
    var x = 0, y = 0, queued = false;
    function apply() { queued = false; glow.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)'; }
    card.addEventListener('mouseenter', function () { glow.style.opacity = 1; });
    card.addEventListener('mouseleave', function () { glow.style.opacity = 0; });
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      x = e.clientX - r.left; y = e.clientY - r.top;
      if (!queued) { queued = true; window.requestAnimationFrame(apply); }
    });
  }

  function bindTilt(card) {
    var amp = 4, x = 0, y = 0, queued = false;
    var glare = card.querySelector('.gosu-fx__glare');
    function apply() {
      queued = false;
      card.style.transform =
        'perspective(950px) rotateX(' + (-y * amp) + 'deg) rotateY(' + (x * amp) + 'deg) scale(1.015)';
      if (glare) {
        glare.style.setProperty('--gx', (x + 0.5) * 100 + '%');
        glare.style.setProperty('--gy', (y + 0.5) * 100 + '%');
      }
    }
    card.addEventListener('mouseenter', function () { if (glare) glare.style.opacity = 1; });
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      x = (e.clientX - r.left) / r.width - 0.5;
      y = (e.clientY - r.top) / r.height - 0.5;
      if (!queued) { queued = true; window.requestAnimationFrame(apply); }
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
      if (glare) glare.style.opacity = 0;
    });
  }

  function initSpark() {
    if (!document.body || document.body.getAttribute('data-gosu-spark') !== 'true') return null;
    var canvas = document.getElementById('gosu-fx-spark');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'gosu-fx-spark';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);
    }
    var ctx = canvas.getContext('2d');
    var sparks = [], raf = 0, running = false;
    var DUR = 440, SIZE = 12, RAD = 24, COUNT = 10, COLOR = '#f4c63f';
    function resize() { canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
    resize();
    window.addEventListener('resize', resize);
    function easeOut(t) { return t * (2 - t); }
    function draw(ts) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      sparks = sparks.filter(function (s) {
        var e = ts - s.t; if (e >= DUR) return false;
        var p = e / DUR, ea = easeOut(p), d = ea * RAD, len = SIZE * (1 - ea);
        ctx.strokeStyle = COLOR; ctx.lineWidth = 2; ctx.beginPath();
        ctx.moveTo(s.x + d * Math.cos(s.a), s.y + d * Math.sin(s.a));
        ctx.lineTo(s.x + (d + len) * Math.cos(s.a), s.y + (d + len) * Math.sin(s.a));
        ctx.stroke(); return true;
      });
      if (sparks.length) { raf = window.requestAnimationFrame(draw); }
      else { running = false; ctx.clearRect(0, 0, canvas.width, canvas.height); }
    }
    function burst(x, y) {
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      for (var i = 0; i < COUNT; i++) sparks.push({ x: x, y: y, a: 2 * Math.PI * i / COUNT, t: now });
      if (!running) { running = true; raf = window.requestAnimationFrame(draw); }
    }
    window.addEventListener('click', function (e) { burst(e.clientX, e.clientY); });
    return { burst: burst, canvas: canvas };
  }

  function init() {
    var e = env();
    var tagged = tagTargets(document, SELECTOR_MAP);
    if (e.fine && !e.reduce) {
      document.querySelectorAll('.gosu-fx--glow').forEach(bindGlow);
      document.querySelectorAll('.gosu-fx--tilt').forEach(bindTilt);
    }
    if (!e.reduce) initSpark();
    return tagged;
  }

  window.GosuFX = {
    SELECTOR_MAP: SELECTOR_MAP,
    env: env,
    tagTargets: tagTargets,
    bindGlow: bindGlow,
    bindTilt: bindTilt,
    initSpark: initSpark,
    init: init
  };

  if (!window.GOSU_FX_NO_AUTOINIT) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})(window, document);
